import React from 'react';
import { NavLink, Link } from 'react-router-dom';
// import { DropdownButton, Dropdown } from 'react-bootstrap';
// import ReactTooltip from 'react-tooltip';
import { local_routes } from 'utils/Routes';
import { org_friendly_url } from 'Api/Api';
// , user_access_level, user_account_level
import './style.css';

import DownloadAssetsButton from 'components/DownloadAssetsButton/DownloadAssetsButton';

export default class SubmittedPresentationTable extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            showComponent: false,
            assets_array: []
        };
        this.workspace_base_url = "";
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
        

    }

    onClickAccept = () => {
        console.log("onClickAccept");
        this.props.acceptPK(this.props.presentation_info,this.props.presenter_info);
    }

    onClickReject = () => {
        console.log("onClickReject");
        this.props.rejectPK(this.props.presentation_info);
    }

    getItemStyle = (draggableStyle, isDragging) => ({
        userSelect: "none",
        padding: 0,
        margin: `0 0 0px 0`,
        background: isDragging ? "#84C9BC" : "transparent",
        // width: `900px`,
        display:"flex",
        // justifyContent:"space-between",
        borderBottom: "1px solid #dee2e6",
        ...draggableStyle
      });

    render(){
        const {provided, snapshot} = this.props;
        return (
            <React.Fragment>
            <tr className=""
                //ref={provided.innerRef}
                //style={this.getItemStyle(provided.draggableStyle, snapshot.isDragging)}
                //{...provided.dragHandleProps}
            >
                <td className="border-none" style={{ width: "30%" }}>
                    { this.props.presentation_info.status_code === 1 ?
                    <Link target="_blank" to={`${this.workspace_base_url}${local_routes.presentations}/${this.props.presentation_info.friendly_url}`}>
                        {this.props.presentation_info.entity_name}
                    </Link>
                    :
                    <React.Fragment>
                        {this.props.presentation_info.entity_name}
                    </React.Fragment>
                    }
                </td>
                { this.props.presenter_info &&
                  <td className="border-none" style={{ width: "35%" }}>
                      <NavLink target="_blank" to={`${this.workspace_base_url}${local_routes.users}/${this.props.presenter_info.friendly_url}`}>
                          {this.props.presenter_info.friendly_url}
                      </NavLink>
                  </td>
                }
                {/*
                <td className="border-none" style={{ width: "20%" }}>
                    <DownloadAssetsButton
                        entity_info={{...this.props.presentation_info,entity_type:'presentations'}}
                    />

                </td>
                */}
                <td className="border-none" style={{ width: "15%", display: 'flex' }}>
                    <div>
                        <button 
                            className="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons" 
                            onClick={this.onClickAccept}
                        >
                            Accept
                        </button>
                    </div>
                    <div>
                        <button 
                            className="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons" 
                            onClick={this.onClickReject}
                        >
                            Reject
                        </button>
                    </div>

                </td>
            </tr>
            {/*
            {provided.placeholder ? (
                    <tr>
                        <td>
                            {provided.placeholder}
                        </td>
                    </tr>
                ) : null
            }
            */}
            </React.Fragment>
        )
    }
}